/**
 * Constants for Calendar module
 */

export const EVENT_TYPE_COLORS: Record<string, string> = {
  meeting: 'bg-blue-500',
  deadline: 'bg-red-500',
  delivery: 'bg-green-500',
  audit: 'bg-purple-500',
  inspection: 'bg-yellow-500',
  review: 'bg-indigo-500',
  training: 'bg-pink-500',
  other: 'bg-gray-500',
};

export const EVENT_TYPE_BG_COLORS: Record<string, string> = {
  meeting: '#3b82f6',
  deadline: '#ef4444',
  delivery: '#10b981',
  audit: '#a855f7',
  inspection: '#eab308',
  review: '#6366f1',
  training: '#ec4899',
  other: '#6b7280',
};

export const EVENT_TYPE_LABELS: Record<string, string> = {
  meeting: 'Meeting',
  deadline: 'Deadline',
  delivery: 'Delivery',
  audit: 'Audit',
  inspection: 'Inspection',
  review: 'Review',
  training: 'Training',
  other: 'Other',
};

export const STATUS_COLORS: Record<string, string> = {
  scheduled: 'bg-blue-100 text-blue-800',
  in_progress: 'bg-yellow-100 text-yellow-800',
  completed: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};

export const ALL_EVENT_TYPES = [
  'meeting',
  'deadline',
  'delivery',
  'audit',
  'inspection',
  'review',
  'training',
  'other',
];

export const ITEMS_PER_PAGE = 10;
